module.exports = __webpack_public_path__ + "static/media/personWhite.cf59a9ba.svg";